import type { FC } from "react";

interface ChapterItemIndexProps {
  index: number;
}

/** Displays the chapter number index with dark background */
export const ChapterItemIndex: FC<ChapterItemIndexProps> = ({ index }) => {
  const number = index + 1;

  return (
    <div className="flex h-6 w-6 items-center justify-center rounded-lg bg-slate-900">
      <span className="text-xs font-bold text-white">{number}</span>
    </div>
  );
};
